export const UserAccountSelectedIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.21618 3.79568C1.5 4.78143 1.5 6.18757 1.5 8.99991C1.5 11.8122 1.5 13.2184 2.21618 14.2041C2.44748 14.5225 2.72745 14.8024 3.0458 15.0337C4.03155 15.7499 5.4377 15.7499 8.25 15.7499H9.75C12.5623 15.7499 13.9684 15.7499 14.9542 15.0337C15.2725 14.8024 15.5525 14.5225 15.7838 14.2041C16.5 13.2184 16.5 11.8122 16.5 8.99991C16.5 6.18757 16.5 4.78143 15.7838 3.79568C15.5525 3.47733 15.2725 3.19736 14.9542 2.96606C13.9684 2.24988 12.5623 2.24988 9.75 2.24988H8.25C5.4377 2.24988 4.03155 2.24988 3.0458 2.96606C2.72745 3.19736 2.44748 3.47733 2.21618 3.79568ZM6.375 8.24991C7.20343 8.24991 7.875 7.57828 7.875 6.74988C7.875 5.92145 7.20343 5.24988 6.375 5.24988C5.54657 5.24988 4.875 5.92145 4.875 6.74988C4.875 7.57828 5.54657 8.24991 6.375 8.24991Z"
        fill="#1453F5"
      />
      <path
        d="M12.75 2.24988H5.25C3.17893 2.24988 1.5 3.92881 1.5 5.99988V11.9999C1.5 14.0709 3.17893 15.7499 5.25 15.7499H12.75C14.8211 15.7499 16.5 14.0709 16.5 11.9999V5.99988C16.5 3.92881 14.8211 2.24988 12.75 2.24988Z"
        stroke="#1453F5"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 6.74988H13.5"
        stroke="#1453F5"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path
        d="M10.5 9.37488H12.75"
        stroke="#1453F5"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path
        d="M3.75 11.9999C4.65623 10.0641 8.03415 9.93671 9 11.9999"
        stroke="#1453F5"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.875 6.74988C7.875 7.57827 7.20343 8.24989 6.375 8.24989C5.54657 8.24989 4.875 7.57827 4.875 6.74988C4.875 5.92145 5.54657 5.24988 6.375 5.24988C7.20343 5.24988 7.875 5.92145 7.875 6.74988Z"
        stroke="#1453F5"
        strokeWidth="1.25"
      />
    </svg>
  );
};
